import React from "react";

import { Typography, Box, Container } from "@mui/material";

import { useTranslation } from "i18n";

const ANVR_TRAVEL_CONDITIONS =
  "https://www.anvr.nl/reizigersvoorwaarden.pdf";
const SGR_GUARANTEE =
  "https://www.sgr.nl/wp/reisorganisaties/garantieregeling/";
const CALAMITY_FUND =
  "https://www.calamiteitenfonds.nl/garantieregeling/";

const PRIVACY_POLICY = {
  en: {
    heading: "GENERAL TERMS AND CONDITIONS SATYAM TOURS B.V.",
    clauses: [
      {
        number: "1",
        body: "These general terms and conditions apply to all (online) bookings made through Satyam Tours B.V.",
      },
      {
        number: "2",
        body: "Satyam Tours B.V. is a member of the Dutch Association of Travel Agents and Tour Operators (ANVR). It therefore applies the ANVR travel conditions insofar as these general terms and conditions do not contain any additions. The ANVR travel conditions can be consulted via the following link:",
        link: ANVR_TRAVEL_CONDITIONS,
      },
      {
        number: "3",
        body: "Bookings of single travel services, such as the purchase of airline tickets, are subject to the ANVR booking conditions for individual travel services in accordance with section 3 and these general terms and conditions.",
      },
      {
        number: "4",
        body: "When booking airline tickets, the general terms and conditions of the service providers (airlines) also apply.",
      },
      {
        number: "5",
        body: "If a non-refundable airline ticket is chosen, the right to a refund lapses upon cancellation of the booking. Satyam Tours B.V. will in that case, if requested, make efforts to change the booked airline ticket within the margins of the service provider’s general terms and conditions. Any change fees associated with this are entirely at the traveler’s expense and risk.",
      },
      {
        number: "6",
        body: "Bookings that qualify as a linked travel arrangement are subject to the ANVR conditions in accordance with section 2 and these general terms and conditions.",
      },
      {
        number: "7",
        body: "Bookings of package holidays are subject to the ANVR booking conditions for package holidays in accordance with section 1 and these general terms and conditions.",
      },
      {
        number: "8",
        body: "Satyam Tours B.V. reserves the right to implement price increases resulting from an increase in exchange rates that are relevant to the package holiday.",
      },
      {
        number: "9",
        body: "Bookings of package holidays are also subject to the conditions of the guarantee scheme of the Travel Compensation Fund (SGR). Within the limits of this scheme, consumers are offered additional protection in the event that Satyam Tours B.V. encounters financial difficulties. If this unexpectedly occurs, consumers may claim performance or a refund of their booking. The SGR conditions can be consulted via the following link:",
        link: SGR_GUARANTEE,
      },
      {
        number: "10",
        body: "Bookings of package holidays are also subject to the conditions of the Calamity Fund Foundation (Stichting Calamiteitenfonds). On this basis, consumers are entitled, within the limits of the applicable conditions, to compensation in the event of calamities. A successful claim for this compensation requires an abnormal event caused by civil unrest or a natural disaster. The conditions of the Calamity Fund Foundation can be consulted via the following link:",
        link: CALAMITY_FUND,
      },
    ],
    closing:
      "Satyam Tours B.V. is established in The Hague and is registered in the Commercial Register of the Chamber of Commerce under number 57235341.",
  },
  nl: {
    heading: "ALGEMENE VOORWAARDEN SATYAM TOURS B.V.",
    clauses: [
      {
        number: "1",
        body: "Deze algemene voorwaarden zijn van toepassing op alle (online) boekingen die worden gedaan via Satyam Tours B.V.",
      },
      {
        number: "2",
        body: "Satyam Tours B.V. is aangesloten bij de Algemene Nederlandse Vereniging van Reisondernemingen (ANVR). Zij hanteert derhalve de ANVR-reisvoorwaarden voor zover er in deze algemene voorwaarden geen aanvullingen zijn opgenomen. De ANVR-reisvoorwaarden zijn te raadplegen via de volgende link:",
        link: ANVR_TRAVEL_CONDITIONS,
      },
      {
        number: "3",
        body: "Op boekingen van enkelvoudige reisdiensten, zoals de aankoop van vliegtickets, zijn de ANVR-boekingsvoorwaarden voor losse reisdiensten conform paragraaf 3 en deze algemene voorwaarden van toepassing.",
      },
      {
        number: "4",
        body: "Bij het boeken van vliegtickets zijn tevens de algemene voorwaarden van de dienstverleners (luchtvaartmaatschappijen) van toepassing.",
      },
      {
        number: "5",
        body: "Indien er wordt gekozen voor een non-refundable vliegticket vervalt het recht op restitutie bij een annulering van de boeking. Satyam Tours B.V. zal zich in dat geval, desgewenst, inspannen om, binnen de marges van de algemene voorwaarden van de dienstverlener, het geboekte vliegticket te wijzigen. De (eventuele) wijzigingskosten die hieraan verbonden zijn komen volledig voor rekening en risico van de reiziger.",
      },
      {
        number: "6",
        body: "Op boekingen die kwalificeren als een gekoppeld reisarrangement zijn de ANVR-voorwaarden conform paragraaf 2 en deze algemene voorwaarden van toepassing.",
      },
      {
        number: "7",
        body: "Op boekingen van pakketreizen zijn de ANVR-boekingsvoorwaarden voor pakketreizen conform paragraaf 1 en deze algemene voorwaarden van toepassing.",
      },
      {
        number: "8",
        body: "Satyam Tours B.V. behoudt zich het recht voor om prijsverhogingen door te voeren die het gevolg zijn van een verhoging van wisselkoersen die voor de pakketreis van belang zijn.",
      },
      {
        number: "9",
        body: "Op boekingen van pakketreizen zijn de voorwaarden van de garantieregeling van de Stichting Garantiefonds Reisgelden (SGR) eveneens van toepassing. Binnen de grenzen van deze regeling wordt aan consumenten aanvullende bescherming geboden in het geval dat Satyam Tours B.V. in financiële problemen komt te verkeren. Indien dit onverhoopt het geval is kunnen consumenten aanspraak maken op de uitvoering of terugbetaling van hun boeking. De SGR-voorwaarden zijn te raadplegen via de volgende link:",
        link: SGR_GUARANTEE,
      },
      {
        number: "10",
        body: "Op boekingen van pakketreizen zijn ook de voorwaarden van Stichting Calamiteitenfonds van toepassing. Op basis hiervan hebben consumenten binnen de grenzen van de geldende voorwaarden recht op een compensatie bij calamiteiten. Voor een succesvol beroep op deze compensatie moet er sprake zijn van een door een molest of een natuurramp veroorzaakte abnormale gebeurtenis. De voorwaarden van de Stichting Calamiteitenfonds zijn te raadplegen via de volgende link:",
        link: CALAMITY_FUND,
      },
    ],
    closing:
      "Satyam Tours B.V. is gevestigd te Den Haag en staat ingeschreven in het Handelsregister van de Kamer van Koophandel onder het nummer 57235341.",
  },
};

const PrivacyPolicy = () => {
  const { locale } = useTranslation();
  const copy = locale === "en" ? PRIVACY_POLICY.en : PRIVACY_POLICY.nl;

  return (
    <Box sx={{ backgroundColor: "#f8f8f8" }} py={8}>
      <Container>
        <Typography variant="h6" fontWeight="bold" mb={3}>
          {copy.heading}
        </Typography>
        <Box className="card" p={2}>
          {copy.clauses.map((clause) => (
            <Typography key={clause.number} mb={2} variant="subtitle2" ml={2}>
              {clause.number}. {clause.body}
              {clause.link ? (
                <>
                  {" "}
                  <a href={clause.link}>{clause.link}.</a>
                </>
              ) : null}
            </Typography>
          ))}
          <Typography>{copy.closing}</Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
